/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioGithubIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-github-prod" */ './utils').then(
			(m) => m.ForgePioGithubIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/icon' },
);

const LazyForgePioGithubSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-github-prod-search-result" */ './utils').then(
			(m) => m.ForgePioGithubSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioGithubIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioGithubIconComponent />
	</Suspense>
);

export const ForgePioGithubSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioGithubSearchResultIconComponent />
	</Suspense>
);
